// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"d181N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preview = require("./dist/preview");
parcelHelpers.exportAll(_preview, exports);

},{"./dist/preview":"1oYQ8","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"1oYQ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "argsEnhancers", function() {
    return argsEnhancers;
});
parcelHelpers.export(exports, "loaders", function() {
    return loaders;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _uuid = require("uuid");
var _previewApi = require("@storybook/preview-api");
var _global = require("@storybook/global");
var _previewErrors = require("@storybook/core-events/preview-errors");
var _this = undefined;
var ADDON_ID = "storybook/actions", EVENT_ID = "".concat(ADDON_ID, "/action-event");
var config = {
    depth: 10,
    clearOnStoryChange: !0,
    limit: 50
};
var findProto = function(obj, callback) {
    var proto = Object.getPrototypeOf(obj);
    return !proto || callback(proto) ? proto : findProto(proto, callback);
}, isReactSyntheticEvent = function(e) {
    return !!(typeof e == "object" && e && findProto(e, function(proto) {
        return /^Synthetic(?:Base)?Event$/.test(proto.constructor.name);
    }) && typeof e.persist == "function");
}, serializeArg = function(a) {
    if (isReactSyntheticEvent(a)) {
        var e = Object.create(a.constructor.prototype, Object.getOwnPropertyDescriptors(a));
        e.persist();
        var viewDescriptor = Object.getOwnPropertyDescriptor(e, "view"), view = viewDescriptor === null || viewDescriptor === void 0 ? void 0 : viewDescriptor.value;
        return typeof view == "object" && (view === null || view === void 0 ? void 0 : view.constructor.name) === "Window" && Object.defineProperty(e, "view", (0, _objectSpreadProps._)((0, _objectSpread._)({}, viewDescriptor), {
            value: Object.create(view.constructor.prototype)
        })), e;
    }
    return a;
}, generateId = function() {
    return typeof crypto == "object" && typeof crypto.getRandomValues == "function" ? (0, _uuid.v4)() : Date.now().toString(36) + Math.random().toString(36).substring(2);
};
function action(name) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var actionOptions = (0, _objectSpread._)({}, config, options), handler = function handler() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (options.implicit) {
            var _this;
            var storyRenderer = (_this = "__STORYBOOK_PREVIEW__" in (0, _global.global) ? (0, _global.global).__STORYBOOK_PREVIEW__ : void 0) === null || _this === void 0 ? void 0 : _this.storyRenders.find(function(render) {
                return render.phase === "playing" || render.phase === "rendering";
            });
            if (storyRenderer) {
                var _window_FEATURES, _window;
                var deprecated = !((_window = window) === null || _window === void 0 ? void 0 : (_window_FEATURES = _window.FEATURES) === null || _window_FEATURES === void 0 ? void 0 : _window_FEATURES.disallowImplicitActionsInRenderV8), error = new (0, _previewErrors.ImplicitActionsDuringRendering)({
                    phase: storyRenderer.phase,
                    name: name,
                    deprecated: deprecated
                });
                if (deprecated) console.warn(error);
                else throw error;
            }
        }
        var channel = (0, _previewApi.addons).getChannel(), id = generateId(), minDepth = 5, serializedArgs = args.map(serializeArg), normalizedArgs = args.length > 1 ? serializedArgs : serializedArgs[0], actionDisplayToEmit = {
            id: id,
            count: 0,
            data: {
                name: name,
                args: normalizedArgs
            },
            options: (0, _objectSpreadProps._)((0, _objectSpread._)({}, actionOptions), {
                maxDepth: minDepth + (actionOptions.depth || 3),
                allowFunction: actionOptions.allowFunction || !1
            })
        };
        channel.emit(EVENT_ID, actionDisplayToEmit);
    };
    return handler.isAction = !0, handler;
}
var isInInitialArgs = function(name, initialArgs) {
    return (0, _typeOf._)(initialArgs[name]) > "u" && !(name in initialArgs);
}, inferActionsFromArgTypesRegex = function(context) {
    var initialArgs = context.initialArgs, argTypes = context.argTypes, id = context.id, actions = context.parameters.actions;
    if (!actions || actions.disable || !actions.argTypesRegex || !argTypes) return {};
    var argTypesRegex = new RegExp(actions.argTypesRegex);
    return Object.entries(argTypes).filter(function(param) {
        var _param = (0, _slicedToArray._)(param, 1), name = _param[0];
        return !!argTypesRegex.test(name);
    }).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), name = _param[0], argType = _param[1];
        return isInInitialArgs(name, initialArgs) && (acc[name] = action(name, {
            implicit: !0,
            id: id
        })), acc;
    }, {});
}, addActionsFromArgTypes = function(context) {
    var initialArgs = context.initialArgs, argTypes = context.argTypes, actions = context.parameters.actions;
    return (actions === null || actions === void 0 ? void 0 : actions.disable) || !argTypes ? {} : Object.entries(argTypes).filter(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), name = _param[0], argType = _param[1];
        return !!argType.action;
    }).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), name = _param[0], argType = _param[1];
        return isInInitialArgs(name, initialArgs) && (acc[name] = action(typeof argType.action == "string" ? argType.action : name)), acc;
    }, {});
};
var argsEnhancers = [
    addActionsFromArgTypes,
    inferActionsFromArgTypesRegex
];
var attachActionsToFunctionMocks = function(context) {
    var args = context.args, actions = context.parameters.actions;
    (actions === null || actions === void 0 ? void 0 : actions.disable) || Object.entries(args).filter(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), value = _param[1];
        return typeof value == "function" && "_isMockFunction" in value && value._isMockFunction;
    }).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        var previous = value.getMockImplementation();
        if ((previous === null || previous === void 0 ? void 0 : previous._actionAttached) !== !0 && (previous === null || previous === void 0 ? void 0 : previous.isAction) !== !0) {
            var _this1 = _this;
            var implementation = function() {
                for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                    params[_key] = arguments[_key];
                }
                return action(key).apply(_this1, (0, _toConsumableArray._)(params)), previous === null || previous === void 0 ? void 0 : previous.apply(void 0, (0, _toConsumableArray._)(params));
            };
            implementation._actionAttached = !0, value.mockImplementation(implementation);
        }
    });
}, loaders = [
    attachActionsToFunctionMocks
];

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_sliced_to_array":"jzEiA","@swc/helpers/_/_to_consumable_array":"4Hwej","@swc/helpers/_/_type_of":"cHZd3","uuid":"23yP7","@storybook/preview-api":"3zhcF","@storybook/global":"i6gHT","@storybook/core-events/preview-errors":"ktqKb","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"23yP7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", function() {
    return 0, _v1JsDefault.default;
});
parcelHelpers.export(exports, "v3", function() {
    return 0, _v3JsDefault.default;
});
parcelHelpers.export(exports, "v4", function() {
    return 0, _v4JsDefault.default;
});
parcelHelpers.export(exports, "v5", function() {
    return 0, _v5JsDefault.default;
});
parcelHelpers.export(exports, "NIL", function() {
    return 0, _nilJsDefault.default;
});
parcelHelpers.export(exports, "version", function() {
    return 0, _versionJsDefault.default;
});
parcelHelpers.export(exports, "validate", function() {
    return 0, _validateJsDefault.default;
});
parcelHelpers.export(exports, "stringify", function() {
    return 0, _stringifyJsDefault.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _parseJsDefault.default;
});
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"gd237","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"gd237":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"6Vt90","./rng.js":"6dk3H","./stringify.js":"89Dto","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"6Vt90":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID: randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"6dk3H":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rng;
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"89Dto":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", function() {
    return unsafeStringify;
});
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"buQwZ","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"buQwZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"71yoU","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"71yoU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.014389e1.js.map
